import React from "react";
import Facts from "components/Facts";

import { addRoundedRect } from "../svgUtils";
import { mapDefs } from "../../render";

const outerRadius = 100;
const frameWidth = 17;
const framePadding = 1;
const innerFrameRadius = outerRadius - frameWidth;

export default {
  layout: { radius: outerRadius },
  render: {
    enter: (item) => {
      const { elem: e, label } = item;

      const circularFramePath = "circularFramePath";
      const arcRadius = innerFrameRadius + framePadding;
      const svgDefs = mapDefs();
      const pathSel = svgDefs.selectAll("#" + circularFramePath);
      if (pathSel.length == 0) {
        svgDefs
          .append("path")
          .attr("id", circularFramePath)
          .attr(
            "d",
            `M ${-arcRadius} 0 A ${arcRadius} ${arcRadius} 0 0 1 ${arcRadius} 0`
          );
      }

      e.append("circle").attr("fill", "white").attr("r", outerRadius);
      item.hostLabel = e
        .append("text")
        .attr("font-size", `${frameWidth - framePadding * 2}px`)
        .attr("textLength", Math.PI * arcRadius)
        .append("textPath")
        .attr("href", `#${circularFramePath}`);
      item.hostLabel.text(item.data ? JSON.parse(item.data).host : item.label);

      item.clientsText = e
        .append("text")
        .attr("text-anchor", "end")
        .attr("dominant-baseline", "middle")
        .attr("x", -3)
        .attr("font-size", "20px")
        .text("-");
      e.append("text")
        .attr("dominant-baseline", "middle")
        .attr("x", 3)
        .text("clients");

      item.opsPerSecText = e
        .append("text")
        .attr("text-anchor", "end")
        .attr("dominant-baseline", "middle")
        .attr("x", -3)
        .attr("y", -22)
        .attr("font-size", "20px")
        .text("-");
      e.append("text")
        .attr("dominant-baseline", "middle")
        .attr("x", 3)
        .attr("y", -22)
        .text("ops/sec");

      item.cpuText = e
        .append("text")
        .attr("text-anchor", "end")
        .attr("dominant-baseline", "middle")
        .attr("x", -3)
        .attr("y", 22)
        .attr("font-size", "20px")
        .text("-");
      e.append("text")
        .attr("dominant-baseline", "middle")
        .attr("x", 3)
        .attr("y", 22)
        .text("cpu cores");

      // background
      const thickness = (frameWidth - framePadding * 2) / 2;
      const angleRadians = Math.PI * 0.95;
      const ofs = Math.PI * 0.025;
      const radius = outerRadius - frameWidth / 2;
      const startX = -Math.cos(ofs) * radius;
      const startY = Math.sin(ofs) * radius;
      const endX = -Math.cos(angleRadians + ofs) * radius;
      const endY = Math.sin(angleRadians + ofs) * radius;

      e.append("path")
        .attr("fill", "none")
        .attr("stroke-width", `${thickness}px`)
        .attr("stroke", "#f0f0f0")
        .attr(
          "d",
          `M ${startX} ${startY} A ${radius} ${radius} 0 0 0 ${endX} ${endY}`
        );

      item.memoryBar = e
        .append("path")
        .attr("fill", "none")
        .attr("stroke-width", `${thickness}px`);
    },
    update: (item) => {
      const data = item.data ? JSON.parse(item.data) : null;
      if (!data) return;
      item.hostLabel.text(data.host || item.label);
    },
  },
  eventHandlers: {
    status: (item, data, ui) => {
      const dataObj = JSON.parse(data);

      item.clientsText.text(dataObj.connected_clients.toLocaleString());
      item.opsPerSecText.text(dataObj.ops_per_sec.toLocaleString());

      const totalCpu = dataObj.user_cpu_frac + dataObj.sys_cpu_frac;
      item.cpuText.text(
        totalCpu == 0 ? "0.00" : Math.round(totalCpu * 100) / 100
      );

      const memFrac = dataObj.used_memory / dataObj.max_memory;
      const angleRadians = memFrac * Math.PI * 0.95;
      const ofs = Math.PI * 0.025;
      const radius = outerRadius - frameWidth / 2;
      const startX = -Math.cos(ofs) * radius;
      const startY = Math.sin(ofs) * radius;
      const endX = -Math.cos(angleRadians + ofs) * radius;
      const endY = Math.sin(angleRadians + ofs) * radius;

      item.memoryBar
        .attr(
          "stroke",
          memFrac < 0.7 ? "green" : memFrac < 0.9 ? "orange" : "red"
        )
        .attr(
          "d",
          `M ${startX} ${startY} A ${radius} ${radius} 0 0 0 ${endX} ${endY}`
        );
    },
  },
  renderInfoHead: (t) => t.data || "(No full name)",
  renderInfoBody: (t) => (
    <Facts>
      <Facts.Fact label="Data" value={t.data || ""} />
    </Facts>
  ),
};
